
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useNavigate, useLocation } from "react-router-dom"
import { Book, MessageCircle, BookOpen, Bell, Map } from "lucide-react"
import { useSession } from "@supabase/auth-helpers-react";
import { useIsMobile } from "@/hooks/use-mobile";

export function CommunityTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSession();
  const isMobile = useIsMobile();
  
  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.includes('/graceful-petitions')) return 'prayers';
    if (path.includes('/journeys')) return 'journeys';
    if (path.includes('/daily-devotionals')) return 'devotionals';
    if (path.includes('/journal')) return 'journal';
    return 'prayers';
  };

  const handleNavigation = (path: string) => {
    // Scroll to top before navigation
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    navigate(path);
  };

  return (
    <div className="fixed bottom-16 left-0 right-0 z-10">
      <div className="bg-gradient-to-r from-gray-900 via-slate-800 to-gray-900 shadow-2xl w-full backdrop-blur-lg border-t border-white/10">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/10 via-blue-800/5 to-blue-900/10 opacity-50"></div>
        <Tabs defaultValue={getCurrentTab()} value={getCurrentTab()} className="w-full max-w-6xl mx-auto relative">
          <TabsList className="grid w-full grid-cols-4 bg-transparent h-auto p-0">
            <TabsTrigger 
              value="prayers" 
              className="flex flex-col items-center justify-center py-4 px-3 gap-2 rounded-none 
              border-b-3 border-transparent data-[state=active]:bg-app-accent/30 data-[state=active]:border-app-accent 
              data-[state=active]:shadow-lg transition-all duration-300 hover:bg-app-accent/10 group"
              onClick={() => handleNavigation("/graceful-petitions")}
            >
              <div className="relative">
                <MessageCircle className="w-6 h-6 text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200" />
                <div className="absolute inset-0 bg-app-accent/20 rounded-full scale-0 group-hover:scale-110 data-[state=active]:scale-110 transition-transform duration-200 blur-sm"></div>
              </div>
              <span className="text-xs font-semibold text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200">
                Prayers
              </span>
            </TabsTrigger>
            
            <TabsTrigger 
              value="journeys" 
              className="flex flex-col items-center justify-center py-4 px-3 gap-2 rounded-none 
              border-b-3 border-transparent data-[state=active]:bg-app-accent/30 data-[state=active]:border-app-accent 
              data-[state=active]:shadow-lg transition-all duration-300 hover:bg-app-accent/10 group"
              onClick={() => handleNavigation("/journeys")}
            >
              <div className="relative">
                <Map className="w-6 h-6 text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200" />
                <div className="absolute inset-0 bg-app-accent/20 rounded-full scale-0 group-hover:scale-110 data-[state=active]:scale-110 transition-transform duration-200 blur-sm"></div>
              </div>
              <span className="text-xs font-semibold text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200">
                Journeys
              </span>
            </TabsTrigger>
            
            <TabsTrigger 
              value="journal" 
              className="flex flex-col items-center justify-center py-4 px-3 gap-2 rounded-none 
              border-b-3 border-transparent data-[state=active]:bg-app-accent/30 data-[state=active]:border-app-accent 
              data-[state=active]:shadow-lg transition-all duration-300 hover:bg-app-accent/10 group"
              onClick={() => handleNavigation("/journal")}
            >
              <div className="relative">
                <Book className="w-6 h-6 text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200" />
                <div className="absolute inset-0 bg-app-accent/20 rounded-full scale-0 group-hover:scale-110 data-[state=active]:scale-110 transition-transform duration-200 blur-sm"></div>
              </div>
              <span className="text-xs font-semibold text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200">
                Journal
              </span>
            </TabsTrigger>
            
            <TabsTrigger 
              value="devotionals" 
              className="flex flex-col items-center justify-center py-4 px-3 gap-2 rounded-none 
              border-b-3 border-transparent data-[state=active]:bg-app-accent/30 data-[state=active]:border-app-accent 
              data-[state=active]:shadow-lg transition-all duration-300 hover:bg-app-accent/10 group"
              onClick={() => handleNavigation("/daily-devotionals")}
            >
              <div className="relative">
                <BookOpen className="w-6 h-6 text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200" />
                <div className="absolute inset-0 bg-app-accent/20 rounded-full scale-0 group-hover:scale-110 data-[state=active]:scale-110 transition-transform duration-200 blur-sm"></div>
              </div>
              <span className="text-xs font-semibold text-gray-300 data-[state=active]:text-app-accent group-hover:text-white transition-colors duration-200">
                Devotionals
              </span>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}
